import { render, staticRenderFns } from "./TeacherEdit.vue?vue&type=template&id=f5fdd338&scoped=true&"
import script from "./TeacherEdit.vue?vue&type=script&lang=js&"
export * from "./TeacherEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fdd338",
  null
  
)

export default component.exports